/**
 * The shell's left-sidebar target (KIT_REQUIREMENTS §3 "Left-sidebar renderer"; wp/shell §4.15, §10): the vertical
 * layout renders `<div id="content-renderer-sidebar-left">` beside the page on routes with
 * `meta.contentRenderer: 'sidebar-left'` (the inbox), and `AppContentSidebar` teleports the page's sidebar into it —
 * the `<Teleport>` that replaces legacy `portal-vue` (`<portal to="content-renderer-sidebar-left">`).
 */
export const CONTENT_SIDEBAR_TARGET_ID = 'content-renderer-sidebar-left'

/** Below this width the sidebar leaves the flow and slides in over the content (legacy `media-breakpoint-down(md)`). */
export const CONTENT_SIDEBAR_STATIC_QUERY = '(min-width: 992px)'
